// test1959
(1959 && 0);
